import React from 'react';
import {
  Edit,
  ReferenceField,
  SaveButton,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput,
  Toolbar,
  required,
  useRecordContext,
} from 'react-admin';
import PositionInput from 'components/PositionInput';
import { locationPositionFilter } from 'utils/hrisMappingHelpers';

const EditForm = () => {
  const record = useRecordContext();

  return (
    <>
      <SimpleShowLayout>
        <ReferenceField label="Company" source="company_id" reference="Company" link="show">
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField
          label="Location"
          source="location_id"
          reference="Location"
          link="show"
          emptyText="Company default"
        >
          <TextField source="name" />
        </ReferenceField>
      </SimpleShowLayout>
      <SimpleForm
        toolbar={
          <Toolbar>
            <SaveButton />
          </Toolbar>
        }
      >
        <PositionInput
          validate={[required()]}
          filter={locationPositionFilter(record.location_id)}
        />
        <TextInput label="External ID" source="external_id" validate={[required()]} />
      </SimpleForm>
    </>
  );
};

const HrisPositionMappingEdit = () => (
  <Edit mutationMode="pessimistic" redirect="show">
    <EditForm />
  </Edit>
);

export default HrisPositionMappingEdit;
